import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { keyframes, styled } from '../../system';
export const Spinner = forwardRef((props, ref) => (_jsxs(StyledSvg, { ref: ref, width: "1em", height: "1em", fill: "none", viewBox: "0 0 66 66", ...props, children: [_jsx(StyledSpinnerTrackCircle, { cx: "33", cy: "33", fill: "none", r: "28", stroke: "var(---spinnerTrackBg)", strokeWidth: 8 }), _jsx(StyledSpinnerCircle, { cx: "33", cy: "33", fill: "none", r: "28", stroke: "currentColor", strokeDasharray: "1, 174", strokeDashoffset: "306", strokeLinecap: "round", strokeWidth: 8 })] })));
Spinner.displayName = 'Spinner';
const spinKeyframes = keyframes({
    '0%': { strokeDashoffset: 306 },
    '50%': { strokeDasharray: '40, 134' },
    '100%': {
        strokeDasharray: '1, 174',
        strokeDashoffset: 132
    }
});
const StyledSvg = styled('svg', {});
const StyledSpinnerTrackCircle = styled('circle', {
    stroke: '$$spinnerTrackBg'
});
const StyledSpinnerCircle = styled('circle', {
    animation: `${spinKeyframes} 600ms linear infinite`
});
